import React from 'react';
import PropTypes from 'prop-types';
import { SelectForm } from '@components/form/select';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import {
  CUSTOM_FIELD_TYPES,
  customFieldTypeOptions
} from '@/vacancy_request/components/template-request-form/custom-fields/constants';

/**
 * Selector de tipo del campo custom: abierta / cerrada.
 * Vive dentro del modal, contra su form local — no contra el form de la plantilla.
 */
export const FieldTypeSelect = ({ control, formState, disabled }) => {
  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form.customFields');

  return (
    <SelectForm
      control={control}
      formState={formState}
      id='type'
      title={t('modal.type.label')}
      data={customFieldTypeOptions}
      defaultValue={CUSTOM_FIELD_TYPES.OPEN}
      isSearchable={false}
      disabled={disabled}
      validate={{ required: true }}
      errorPosition='bottom'
    />
  );
};

FieldTypeSelect.propTypes = {
  control: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

FieldTypeSelect.defaultProps = {
  disabled: false
};
